import { useState } from "react";
import { Link } from "react-router-dom";
import { portfolio } from "@/mocks/serra";
import Lightbox from "@/components/Lightbox";

export default function Cases() {
  const [active, setActive] = useState<number | null>(null);
  const featured = portfolio.filter((item) => item.featured);

  return (
    <section id="cases" className="py-24 lg:py-32 bg-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase mb-4 block">
              Cases
            </span>
            <h2 className="text-white text-3xl lg:text-5xl font-bold mb-4">
              Projetos que geram resultado real
            </h2>
            <p className="text-white/55 text-base lg:text-lg">
              Uma seleção de trabalhos que transformaram a presença digital dos
              nossos clientes.
            </p>
          </div>
          <Link
            to="/portfolio"
            className="inline-flex items-center gap-2 text-sm font-medium text-white/70 hover:text-orange transition-colors cursor-pointer whitespace-nowrap border-b border-white/20 hover:border-orange pb-1"
          >
            Ver mais projetos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((item, index) => (
            <button
              key={item.title}
              onClick={() => setActive(index)}
              className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer bg-blue/15 text-left"
            >
              <img
                src={item.image}
                alt={`${item.title} — ${item.category}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bg/90 via-bg/10 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500"></div>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="text-xs font-mono-tech uppercase tracking-wider text-cyan mb-1 block">
                  {item.category}
                </span>
                <h3 className="text-lg font-semibold text-white">{item.title}</h3>
              </div>
              <span className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-bg/70 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>

      {active !== null && (
        <Lightbox
          src={featured[active].image}
          alt={featured[active].title}
          onClose={() => setActive(null)}
        />
      )}
    </section>
  );
}
